const SeverityBadge = ({ severity, darkMode }) => {
  const palette = darkMode
    ? {
        High: "#ef4444",
        Medium: "#f59e0b",
        Low: "#10b981",
        Critical: "#ef4444",
        Default: "#6c757d",
      }
    : {
        High: "#dc3545",
        Medium: "#ffc107",
        Low: "#28a745",
        Critical: "#dc2626",
        Default: "#6c757d",
      };

  const color = palette[severity] || palette.Default;

  const size = 18; // icon size in px
  const commonProps = {
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    ariaHidden: true,
  };

  const icon = (() => {
    switch (severity) {
      case "High":
      case "Critical":
        // Triangle (warning)
        return (
          <svg {...commonProps} role="img">
            <polygon points="8,2 14,14 2,14" fill={color} />
          </svg>
        );
      case "Medium":
        // Diamond (rotated square)
        return (
          <svg {...commonProps} role="img">
            <polygon points="8,2 14,8 8,14 2,8" fill={color} />
          </svg>
        );
      case "Low":
        // Circle (info/low)
        return (
          <svg {...commonProps} role="img">
            <circle cx="8" cy="8" r="6" fill={color} />
          </svg>
        );
      default:
        return (
          <svg {...commonProps} role="img">
            <circle cx="8" cy="8" r="6" fill={palette.Default} />
          </svg>
        );
    }
  })();

  return (
    <span
      title={`${severity} severity`}
      aria-label={`${severity} severity`}
      role="img"
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: size + 8,
        height: size + 8,
        lineHeight: 0,
      }}
    >
      {icon}
    </span>
  );
};

export default SeverityBadge;
